import React from 'react';
import { Button, Tooltip, StackLayout } from '@leagueplatform/genesis-core';

export function InfoModal(props: any) {
  const { content, title, index } = props;
  return (
    <StackLayout css={{ display: 'inline' }} data-testid={`subtitle${index}`}>
      <Tooltip
        align="start"
        side="bottom"
        content={content}
        css={{
          zIndex: 999999999,
          borderRadius: '$none',
          boxShadow: 'none',
          border: '1px solid #66717A',
          maxWidth: 280,
          padding: '12px !important',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '-0.176px',
          top: '3px',
        }}
      >
        <Button
          priority="tertiary"
          quiet
          size="small"
          icon="statusInformationCircle"
          hideLabel
          css={{
            padding: '$none',
            marginLeft: '$half',
            position: 'relative',
            top: '3px',
          }}
        >
          {title}
        </Button>
      </Tooltip>
    </StackLayout>
  );
}
